import {ApplicationForm} from "./single-job/ApplicationForm";

(function () {
    ApplicationForm.init();
})();
